const StyledTheme = {
  main: "#6CCFF6",
  dark: "#001011",
  light: "#FFFFFC",
  contrastText: "#757780",
  white: "#fff",
  whiteBox: "#F5F5F5",
};

export default StyledTheme;
